import { render, staticRenderFns } from "./SmartSearchbarResultSection.vue?vue&type=template&id=2be6ea77&scoped=true&"
import script from "./SmartSearchbarResultSection.vue?vue&type=script&lang=ts&"
export * from "./SmartSearchbarResultSection.vue?vue&type=script&lang=ts&"
import style0 from "./SmartSearchbarResultSection.vue?vue&type=style&index=0&id=2be6ea77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6ea77",
  null
  
)

export default component.exports